import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import Header from 'components/ui/Header';
import Sidebar from 'components/ui/Sidebar';
import Button from 'components/ui/Button';
import ProductTable from './components/ProductTable';
import ProductDetails from './components/ProductDetails';
import AddProductModal from './components/AddProductModal';
import BulkActionsBar from './components/BulkActionsBar';
import FilterToolbar from './components/FilterToolbar';
import GenerateQRModal from './components/GenerateQRModal';
import DownloadQr from './components/DownloadQr';
import ViewProductModal from './components/viewProductModel';
import { EditBatch } from './components/EditBatch';

const ProductManagement = () => {
  const [searchParams] = useSearchParams();
  const token = localStorage.getItem('token')
  const currentUser = JSON.parse(localStorage.getItem('user'));
  const clientIdFromUrl = searchParams.get('client_id')
  
  const [showGenerateQrModal, setShowGenerateQrModal] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(true);
  const [showViewProduct, setShowViewProduct] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [editBatchcontain, setEditBatchcontain] = useState([]);
  const [showDownloadQr, setShowDownloadQr] = useState(false);
  const [showEditBatch, setShowEditBatch] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [permissions, setPermissions] = useState([]);
  const [products, setProducts] = useState([]);
  const [clients, setClients] = useState([]);
  const [filters, setFilters] = useState({
    search: '',
    client: '',
    stockStatus: '',
    priceRange: ''
  });
  
  
  const fetchProducts = async () => {
    try {
      const response = await fetch(import.meta.env.VITE_APP_ADMINURL + '/api/product-data-main', {
        method: 'get',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      const data = await response.json();
      // console.log("i am what you are searching for", data);
      setProducts(data);
    } catch (error) {
      console.error("Error fetching product data:", error);
    }
  };
  const fetchClients = async () => {
    try {
      const response = await fetch(import.meta.env.VITE_APP_ADMINURL + '/api/user-data?type=client'); // Separate endpoint for clients
      const data = await response.json();
      setClients(data); // Assume this returns a list of clients
    } catch (error) {
      console.error("Error fetching client data:", error);
    }
  };

  // Filter products based on the selected filters
  const filteredProducts = products.filter(product => {
    const matchesSearch = product.title.toLowerCase().includes(filters.search.toLowerCase()) ||
      product.product_code.toLowerCase().includes(filters.search.toLowerCase());
    const matchesClient = !filters.client || product.client_id === Number(filters.client);
    const isVisibleToUser = currentUser?.role?.toLowerCase() !== 'client' || product.client_id === currentUser?.id;

    return matchesSearch && matchesClient && isVisibleToUser;
  });
  //const filteredProducts = [];

  const handleSidebarToggle = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  const handleQrSubmit = async () => {
    setShowGenerateQrModal(false);
    await fetchProducts();
  }

  const handleProductSelect = (productId) => {
    setSelectedProducts(prev =>
      prev.includes(productId) ? prev.filter(id => id !== productId) : [...prev, productId]
    );
  };

  const handleSelectAll = (selectAll) => {
    if (selectAll) {
      setSelectedProducts(products.map(p => p.id));
    } else {
      setSelectedProducts([]);
    }
  };

  const handleBulkAction = async (action) => {
    // console.log(`Bulk action: ${action} on products:`, selectedProducts);
    if (action === 'DELETE') {
      const res = await fetch(`${import.meta.env.VITE_APP_ADMINURL}/api/deleteproducts`, {
        method: 'Delete',
        headers: {
          'Authorization': `Bearer ${token}`,
          'content-type': 'application/json'
        },
        body: JSON.stringify({ products: selectedProducts })
      })
      if (!res.ok) { }
    }
    setSelectedProducts([]);
  };

  const handleAddProduct = (productData) => {
    const newProduct = {
      id: products.length + 1,
      ...productData,
      qrCode: "pending",
      createdAt: new Date().toISOString().split('T')[0],
      updatedAt: new Date().toISOString().split('T')[0]
    };
    setProducts([...products, newProduct]);
    setShowAddModal(false);
  };

  const handleUpdateProduct = (updatedProduct) => {
    setProducts(updatedProduct);
    setSelectedProduct(null);
  };

  const handleDeleteProduct = async (productId) => {
    const res = await fetch(`${import.meta.env.VITE_APP_ADMINURL}/api/deleteproduct/${productId}`, {
      method: "DELETE",
      headers: {
        "content-type": "application/json",
        'Authorization': `Bearer ${token}`
      }
    })
    // console.log(res)
    setProducts(products.filter(p => p.id !== productId));

    setSelectedProduct(null);
  };
  const handleGenerateQR = (productId) => {
    // console.log(productId);
    // console.log(products);
    setSelectedProduct(products.find(p => p.id == productId));
    // console.log(selectedProduct);
    setShowGenerateQrModal(true);

  };
  const handleDownloadQr = (productId) => {

    setSelectedProduct(products.find(p => p.id == productId));
    setShowDownloadQr(true);

  };
  const handleViewProduct = async (product) => {
    try {
      setSelectedProduct(product); // For modal title
      setShowViewProduct(true);
    } catch (error) {
      console.error("Failed to fetch batches:", error);
    }
  };
  const handleEditBatch = async (batch) => {
    setEditBatchcontain(batch)
    setShowEditBatch(true)
    setShowViewProduct(false)
    // console.log(batch)
    // console.log(showEditBatch)
  }
  const handleDeleteBatch = async (batch) => {
    if (!batch || !batch.id) {
      console.error("Invalid batch data");
      return;
    }

    const confirmDelete = window.confirm(`Are you sure you want to delete batch: ${batch.batch_code}?`);
    if (!confirmDelete) return;
    const token = localStorage.getItem('token');

    try {
      const response = await fetch(`${import.meta.env.VITE_APP_ADMINURL}/api/batchdelete/${batch.id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        }
      });

      // console.log(response);

      if (!response.ok) {
        throw new Error("Failed to delete batch");
      }
      setShowViewProduct(false)
      await fetchProducts()
      // Remove batch from local state after successful deletion
      // console.log(`Batch ${batch.batch_code} deleted successfully`);
    } catch (error) {
      console.error("Error deleting batch:", error);
      alert("Failed to delete batch. Please try again.");
    }
  };

  const fetchPermission = async () => {
    const response = await fetch(import.meta.env.VITE_APP_ADMINURL + `/api/permission`, {
      method: "get",
      headers: { 'content-type': 'application/json', 'Authorization': `Bearer ${token}` }
    }
    )
    const availablePermissions = await response.json()
    setPermissions(availablePermissions)
    return availablePermissions
  }

  const haspermission = (permName) => {
    return permissions.some(p => p.name === permName);
  }

  //------------------------------------- useEffects---------------------------------------------------------------

  useEffect(() => {
    fetchProducts();
    fetchClients();
  }, []);

  useEffect(() => {
    if (selectedProduct) {
      // console.log('Selected product updated:', selectedProduct);
    }
  }, [selectedProduct]);

  useEffect(() => {
    if (clientIdFromUrl && clients.length > 0) {
      setFilters((prev) => ({
        ...prev,
        client: clientIdFromUrl
      }));
    }
  }, [clientIdFromUrl, clients]);
  // console.log(permissions)
  useEffect(() => {
    if (currentUser) fetchPermission(currentUser);
  }, [currentUser?.email]);


  return (
    <div className="min-h-screen bg-background">
      <Header user={currentUser} onMenuToggle={handleSidebarToggle} sidebarCollapsed={sidebarCollapsed} />
      <Sidebar collapsed={sidebarCollapsed} onToggle={handleSidebarToggle} permissions={permissions} />
      <main className={`pt-header-height nav-transition ${sidebarCollapsed ? 'lg:ml-sidebar-collapsed' : 'lg:ml-sidebar-width'}`}>
        <div className="p-6">
          <div className="mb-8">
            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between">
              <div>
                <h1 className="text-3xl font-heading font-bold text-text-primary mb-2">Product Management</h1>
                <p className="text-text-secondary">Manage your product catalog, inventory, and QR codes</p>
              </div>
              <div className="mt-4 lg:mt-0 flex items-center space-x-3">
                {haspermission('Create Product') &&
                  <Button variant="primary" iconName="Plus" className='text-white' onClick={() => setShowAddModal(true)}>
                    <span>Add Product</span>
                  </Button>
                }
              </div>
            </div>
          </div>

          {/* Filter Toolbar */}
          <FilterToolbar
            filters={filters}
            onFiltersChange={setFilters}
            clients={clients}
            resultCount={filteredProducts.length}
          />

          {/* Bulk Actions Bar */}
          {selectedProducts.length > 0 && (
            <BulkActionsBar
              selectedCount={selectedProducts.length}
              onBulkAction={handleBulkAction}
            />
          )}

          {/* Main Content */}
          <div className="grid grid-cols-1 xl:grid-cols-4 gap-6">
            {/* Product Table */}
            <div className="xl:col-span-3">
              <ProductTable
                products={filteredProducts}
                selectedProducts={selectedProducts}
                onProductSelect={handleProductSelect}
                onSelectAll={handleSelectAll}
                onProductClick={setSelectedProduct}
                onGenerateQR={handleGenerateQR}
                onDownloadQr={handleDownloadQr}
                onViewProduct={handleViewProduct}
                haspermission={haspermission}
              />
            </div>

            {/* Product Details Panel */}
            <div className="xl:col-span-1">
              <ProductDetails
                product={selectedProduct}
                onUpdate={handleUpdateProduct}
                onDelete={handleDeleteProduct}
                onGenerateQR={handleGenerateQR}
                onDownloadQr={handleDownloadQr}
                haspermission={haspermission}
              />
            </div>
          </div>
        </div>
      </main>

      {/* Add Product Modal */}
      {showAddModal && (
        <AddProductModal
          onClose={() => setShowAddModal(false)}
          onSubmit={handleAddProduct}
          clients={clients}
        />
      )}
      {showGenerateQrModal && (
        <GenerateQRModal
          onClose={() => setShowGenerateQrModal(false)}
          onSubmit={handleQrSubmit}
          productId={selectedProduct.id}
        />
      )}
      {showDownloadQr && (
        <DownloadQr
          onClose={() => setShowDownloadQr(false)}
          product={selectedProduct}
        />
      )}
      {
        showViewProduct && (
          <ViewProductModal
            onClose={() => setShowViewProduct(false)}
            product={selectedProduct}
            editBatch={handleEditBatch}
            deleteBatch={handleDeleteBatch}
            haspermission={haspermission}
          />
        )
      }
      {
        showEditBatch && (
          <EditBatch
            batch={editBatchcontain}
            onClose={() => setShowEditBatch(false)}
            currentUser={currentUser}
          />
        )
      }
    </div>
  );
};

export default ProductManagement;
